// router 설정, 메뉴 관리, navigate할 때 사용하는 enum
export enum RoutePath {
  main = '/', // TODO: 제거

  workspaces = '/',
  workspaceNew = '/new',
  plan = '/plan',

  dashboard = '/dashboard/:workspaceId',

  // 기본정보 관리
  setting = '/:workspaceId/setting',
  basicSetting = '/:workspaceId/setting/basic',
  languageSetting = '/:workspaceId/setting/language',
  pointSetting = '/:workspaceId/setting/point/:pointId',
  customFieldSetting = '/:workspaceId/setting/custom-field', // 제거
  themeSetting = '/:workspaceId/setting/theme',
  // pointBasicSetting = '/:workspaceId/setting',

  // 스크린세이버
  screensaver = '/:workspaceId/screensaver',
  content = '/:workspaceId/screensaver/content',
  contentAdd = '/:workspaceId/screensaver/content/add',
  contentDetail = '/:workspaceId/screensaver/content/:contentId',

  schedule = '/:workspaceId/screensaver/schedule',

  // 매장
  tenantManage = '/:workspaceId/tenant',
  tenantInfo = '/:workspaceId/tenant/info',
  tenantChangedInfo = '/:workspaceId/tenant/changed',

  // 카테고리
  category = '/:workspaceId/category',

  // 커스텀 메뉴
  custom = '/:workspaceId/custom',

  // 기기
  machines = '/:workspaceId/machines',
  machineAdd = '/:workspaceId/machines/register',
  machineDetail = '/:workspaceId/machines/:machineId',

  // 통계
  stats = '/:workspaceId/stats',
  totalUsageStats = '/:workspaceId/stats/total-usage',
  machineUsageStats = '/:workspaceId/stats/machine-usage',
  tenantUsageStats = '/:workspaceId/stats/tenant-usage',
  categoryUsageStats = '/:workspaceId/stats/category-usage',

  // 모니터링 관리
  monitoring = '/:workspaceId/monitoring',

  // 메뉴 관리
  customPages = '/:workspaceId/custom-pages',
  pointCustomPages = '/:workspaceId/custom-pages/:pointId',
  pointCustomBoards = '/:workspaceId/custom-pages/:pointId/:customPageId/custom-boards',
  pointCustomBoardAdd = '/:workspaceId/custom-pages/:pointId/:customPageId/custom-boards/add',
  pointCustomBoardDetail = '/:workspaceId/custom-pages/:pointId/:customPageId/custom-boards/:customBoardId',

  // 에러
  errorWithWorkspaceId = '/:workspaceId/error',
  error = '/error',
  notFoundWithWorkspaceId = '/:workspaceId/error/not-found',
  notFound = '/error/not-found',

  // 가이드
  guide = '/guide',
  loginGuide = '/guide/login',
  basicGuide = '/guide/basic',
  workspaceGuide = '/guide/workspace',
  contentsGuide = '/guide/contents',
  scheduleGuide = '/guide/schedule',
  storeGuide = '/guide/store',
}
